$(function() {
    tippy('.js-thumb-action-tippy', {
        arrow: true,
        animation: 'shift-away',
        placement: 'right',
        theme: 'thumb-action',
        duration: [300, 180],
        inertia: true
    });

    tippy('.js-thumb-badge-tippy', {
        arrow: true,
        animation: 'shift-away',
        placement: 'top',
        theme: 'thumb-badge',
        duration: [300, 180],
        inertia: true,
        maxWidth: '220px'
    });
});